import { Button, Form, Input } from "antd"
import { useState } from 'react';


const ChecklistItem = ({ isValid, text }) => (
    <div style={{ color: isValid ? '#52c41a' : '#f5222d', transition: 'color 0.3s' }}>
        {isValid ? '✓' : '✗'} {text}
    </div>
    );

export function SecurePassForm({ onSubmitPass }) {

    const [form] = Form.useForm();

    const [validations, setValidations] = useState({
        upper: false,
        lower: false,
        number: false,
        special: false,
        length: false,
    });

    const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!"#$%&/()]).{12,}$/;

    const handleValuesChange = (_, allValues) => {
    const pass = allValues.pass || ''; 

   
    setValidations({
      upper: /[A-Z]/.test(pass),
      lower: /[a-z]/.test(pass),
      number: /\d/.test(pass),
      special: /[!"#$%&/\\()]/.test(pass),
      length: pass.length >= 12,
    });
  };

  const passwordChecklist = (
    <div>
      <ChecklistItem isValid={validations.upper} text="Al menos una mayúscula" />
      <ChecklistItem isValid={validations.lower} text="Al menos una minúscula" />
      <ChecklistItem isValid={validations.number} text="Al menos un número" />
      <ChecklistItem isValid={validations.special} text="Al menos un caracter especial (!#$%, etc.)" />
      <ChecklistItem isValid={validations.length} text="Mínimo 12 caracteres de longitud" />
    </div>
  );
    

    return (
        <Form
            name="login"
            layout="vertical"
            onFinish={(e) => { onSubmitPass(e) }}
            onValuesChange={handleValuesChange}>
            <Form.Item
                name="pass"
                extra={passwordChecklist}
                rules={[
                    { required: true, message: "Por favor ingresa tu nueva contraseña" },
                    {
                        validator: (_, value) => {
                            if (!value || passwordRegex.test(value)) {
                                return Promise.resolve();
                            }
                            return Promise.reject(
                                new Error(
                                    "La contraseña no cumple con los requisitos de seguridad"
                                )
                            );
                        },
                    },
                ]}>
                <Input.Password />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Actualizar contraseña
                </Button>
            </Form.Item>
        </Form>
    )
}